(function () {
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var moneyFormat = (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      return Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function updateBundlePrices(section) {
    if (!section) return;

    var priceItems = section.querySelectorAll('.bundle-kit__item-price');
    var individualTotalEl = section.querySelector('[data-individual-total]');
    var bundleTotalEl = section.querySelector('[data-bundle-total]');
    var discount = Number(section.getAttribute('data-discount')) || 0;

    if (!priceItems.length || !individualTotalEl || !bundleTotalEl) return;

    var totalCents = 0;

    priceItems.forEach(function (item) {
      var value = Number(item.getAttribute('data-price'));
      if (!Number.isNaN(value) && value > 0) {
        totalCents += value;
      }
    });

    var discountedCents = Math.max(0, Math.round(totalCents * (100 - discount) / 100));

    individualTotalEl.textContent = formatMoney(totalCents);

    if (bundleTotalEl.getAttribute('data-bundle-override') !== 'true') {
      bundleTotalEl.textContent = formatMoney(discountedCents);
    }
  }

  function initBundleKitPrices() {
    var sections = document.querySelectorAll('[data-bundle-price-root]');
    sections.forEach(updateBundlePrices);
  }

  document.addEventListener('DOMContentLoaded', initBundleKitPrices);
  document.addEventListener('shopify:section:load', function (event) {
    updateBundlePrices(event.target);
  });
})();
